// eslint-disable-next-line
import React from 'react';
import cn from './ApplicationCard.module.scss';

export function ApplicationCard({ application }) {
  return (
    <div className={cn.card}>
      <div className={cn.head}>
        <div className={cn.logo}>
          <img src={`${window.location.origin}/wp-content/plugins/apasi-account-manager/assets/images/apasi_logo.png`} />
        </div>
        <div>
          <div className={cn.title}>
            Member card
          </div>
          <div>
            <div>
              <span>Name:</span>
              <span className={cn.headName}>
                  {application.member_firstname} {application.member_lastname}
              </span>
            </div>
            <div>
              <span>Membership #:</span>
              <span className={cn.headMembership}>
                {application.membership_id}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={cn.details}>
        <div className="">
          In the event of death while travelling, call:
          within the U.S.A and Canada, Toll Free
        </div>
        <div className={cn.phone}>866-609-3111</div>
        <div>Outside the U.S.A and Canada, call collect</div>
        <div className={cn.phone}>609-921-2775</div>
        <div>
          For all other membership benefits, call:
          855-746-2727 during business hours.
        </div>
      </div>
    </div>
  )
}
